import React, { useEffect,  useState } from 'react';
import {TitleWiseDashboard,pcrReportinforamation,pcrComments} from '../../../../app/models/Restoration'
import { useStore } from '../../../../app/stores/store';
import { toast } from 'react-toastify';
import { Page,Document,PDFViewer,StyleSheet, View,Text,Image } from '@react-pdf/renderer';
interface PCRPDFComponentProps {
  rowdata: TitleWiseDashboard;
}
function PCRPdfDownload({ rowdata }: PCRPDFComponentProps) {
    const { RestorationStore } = useStore();
    const [loadData, setLoadData] = useState<pcrReportinforamation|null>(null);
    const [pcrLoadComment,setPcrLoadComment]=useState<pcrComments[]>([]);
    
    const loadPCRData = async () => {
        try {
          await RestorationStore.PCRInformation(rowdata.title_Code);
          setLoadData(RestorationStore.pcrReportinforamationdata);
        } catch (error) {
          toast.error('Error fetching PCR comments');
        }};
        const dataCommentLoad = async () => {
            try {
              await RestorationStore.getPCRComments(rowdata.title_Code);
              setPcrLoadComment(RestorationStore.pcrCommentsDetails);
             
            } catch (error) {
              toast.error('Error fetching PCR comments');
            }
          };
        useEffect(() => {
            loadPCRData();
            dataCommentLoad();
            // eslint-disable-next-line 
        },[]);
          const styles = StyleSheet.create({
            container: { flexDirection: 'row',height: 75,backgroundColor: 'white'},
            textContainer: {flex: 2,  justifyContent: 'center',textAlign:'center',paddingRight:16},
            boader: { border: '1px solid black' },
            rightBoader: { borderRight: '1px solid black' },
            removeTopBoader: { border: '1px solid black', borderTop: '0px solid black' },
            bottomBoader: { borderBottom: '1px solid black' },
            boaderTop: {borderTop: '1px solid black'},
            rightLeftBoader: { borderLeft: '1px solid black', borderRight: '1px solid black' },
            page: { padding: 20 },
            box: { flexDirection: 'row', backgroundColor: 'white', alignItems: 'center' },
            logo: { width: '70px', height: '30px', marginLeft: 30, marginRight: 30 },
            title: { fontSize: 14, fontWeight: 'bold' },
            table: { width: '100%' },
            row: { flexDirection: 'row',flexWrap: 'wrap' },
            balckcontentbox: { flexDirection: 'row', height: 15 },
            contentbox: { flexDirection: 'row', backgroundColor: 'white', height: 22 },
            projectDetails: {fontSize: 11, backgroundColor: 'lightgray', width: '100%', textAlign: 'center', height: 22, paddingTop: 5, paddingBottom: 2, fontWeight: 'bold'},
            tableTitle: { width: '30%', textAlign: 'left', fontSize: 10, padding: 3,fontWeight: 'bold'},
            tableData: { width: '70%', textAlign: 'left', fontSize: 10, padding: 3 },
            tableHeader: { backgroundColor: 'lightgray', fontSize: 9, fontWeight: 'bold', height: 22,paddingTop: 5,textAlign: 'center', flexWrap: 'wrap',},
            ChildTableData: { fontSize: 9, wordWrap: 'break-word', flexWrap: 'wrap', padding: 3},
            projectInfoData: { fontSize: 9, wordWrap: 'break-word', flexWrap: 'wrap', padding: 3,width: '19%'},
            projectTitleinfoData: { fontSize: 9, wordWrap: 'break-word', flexWrap: 'wrap', padding: 3,width: '20%'},
            projectInfoTitleEnd: { fontSize: 9, wordWrap: 'break-word', flexWrap: 'wrap', padding: 3,width: '16%'},
            projectInfoheadLine: { fontSize: 9, wordWrap: 'break-word', flexWrap: 'wrap', padding: 3,width: '13%'},
            ProjectChecklistHead: { fontSize: 9, wordWrap: 'break-word', flexWrap: 'wrap', padding: 3,width: '26%'},
            ProjectChecklistData: { fontSize: 9, wordWrap: 'break-word', flexWrap: 'wrap', padding: 3,width: '7%',textAlign: 'center'},
            ProjectChecklistEndHead: { fontSize: 9, wordWrap: 'break-word', flexWrap: 'wrap', padding: 3,width: '27%'},
          });
const PDFComponent=(
  <Document>
      <Page style={[styles.page,styles.boader]} size="A4" wrap>
        <View style={[styles.box,styles.boader,styles.container]} >
          <View>
            <Image src={'../assets/PrasadCorp.jpg'} style={styles.logo} />
          </View>
          <View style={styles.textContainer}>
          <Text style={[styles.title,{fontSize:18}]}>RESTORATION</Text>
          <Text style={[styles.title,{fontSize:15}]}>Project Closure Document</Text>
          </View>
          <View style={styles.textContainer}>
          </View>
        </View>
        <View style={[styles.contentbox,styles.removeTopBoader]}>
          <Text style={{ width:'50%', textAlign:'left', fontSize:9 ,padding:5, fontWeight: 'bold'}}>PCR Number:{loadData?.pcrNumber}</Text>
          <Text style={{ width:'50%', textAlign:'right', fontSize:9,padding:5}}>PCR Date:{loadData?.pcrDate.toString()}</Text>
        </View>
        <View style={[styles.table,styles.removeTopBoader]}>
          <Text style={[styles.projectDetails]}>Project Details</Text>
        </View>
        <View style={[styles.row, styles.removeTopBoader]}>
          <Text style={[styles.projectInfoheadLine, styles.rightBoader]}>Client</Text>
          <Text style={[styles.projectTitleinfoData, styles.rightBoader]}>{loadData?.client}</Text>
          <Text style={[styles.projectInfoheadLine, styles.rightBoader]}>Input Material</Text>
          <Text style={[styles.projectInfoData, styles.rightBoader]}>{loadData?.input_Metrial}</Text>
          <Text style={[styles.projectInfoTitleEnd, styles.rightBoader]}>Start Date</Text>
          <Text style={[styles.projectInfoData]}>{rowdata.start_date}</Text>
        </View>
        <View style={[styles.row, styles.removeTopBoader]}>
          <Text style={[styles.projectInfoheadLine, styles.rightBoader]}>Project</Text>
          <Text style={[styles.projectTitleinfoData, styles.rightBoader]}>{rowdata.title_Name}</Text>
          <Text style={[styles.projectInfoheadLine, styles.rightBoader]}>IM Nos</Text>
          <Text style={[styles.projectInfoData, styles.rightBoader]}>{loadData?.iM_Nos}</Text>
          <Text style={[styles.projectInfoTitleEnd, styles.rightBoader]}>End Date</Text>
          <Text style={[styles.projectInfoData]}>{loadData?.end_Date}</Text>
        </View>
        <View style={[styles.row, styles.removeTopBoader]}>
          <Text style={[styles.projectInfoheadLine, styles.rightBoader]}>Level</Text>
          <Text style={[styles.projectTitleinfoData, styles.rightBoader]}>{loadData?.level}</Text>
          <Text style={[styles.projectInfoheadLine, styles.rightBoader]}>Output Material</Text>
          <Text style={[styles.projectInfoData, styles.rightBoader]}>{loadData?.outPut_Metrial}</Text>
          <Text style={[styles.projectInfoTitleEnd, styles.rightBoader]}>Committed Del. Date</Text>
          <Text style={[styles.projectInfoData]}>{rowdata?.delivery_date}</Text>
        </View>
        <View style={[styles.row, styles.removeTopBoader]}>
          <Text style={[styles.projectInfoheadLine, styles.rightBoader]}>Resolution</Text>
          <Text style={[styles.projectTitleinfoData, styles.rightBoader]}>{rowdata.resolution}</Text>
          <Text style={[styles.projectInfoheadLine, styles.rightBoader]}>OM Nos.</Text>
          <Text style={[styles.projectInfoData, styles.rightBoader]}>{loadData?.oM_Nos}</Text>
          <Text style={[styles.projectInfoTitleEnd, styles.rightBoader]}>Actual Delivery Date</Text>
          <Text style={[styles.projectInfoData]}>{loadData?.actualDeliveryDate}</Text>
        </View>
        <View style={[styles.row, styles.removeTopBoader]}>
          <Text style={[styles.projectInfoheadLine, styles.rightBoader]}>Reels</Text>
          <Text style={[styles.projectTitleinfoData, styles.rightBoader]}>{loadData?.reels}</Text>
          <Text style={[styles.projectInfoheadLine, styles.rightBoader]}>Our OM Nos.</Text>
          <Text style={[styles.projectInfoData, styles.rightBoader]}>{loadData?.our_OM_Nos}</Text>
          <Text style={[styles.projectInfoTitleEnd, styles.rightBoader]}>Estimated Hours</Text>
          <Text style={[styles.projectInfoData]}>{rowdata?.estimate_Hour}</Text>
        </View>
        <View style={[styles.row, styles.removeTopBoader]}>
          <Text style={[styles.projectInfoheadLine, styles.rightBoader]}>Shots</Text>
          <Text style={[styles.projectTitleinfoData, styles.rightBoader]}>{loadData?.shots}</Text>
          <Text style={[styles.projectInfoheadLine, styles.rightBoader]}>LOB Split up</Text>
          <Text style={[styles.projectInfoData, styles.rightBoader]}>{loadData?.lob_Split_up}</Text>
          <Text style={[styles.projectInfoTitleEnd, styles.rightBoader]}>Actual Hours</Text>
          <Text style={[styles.projectInfoData]}>{rowdata?.total_Hours}</Text>
        </View>
        <View style={[styles.row, styles.removeTopBoader]}>
          <Text style={[styles.projectInfoheadLine, styles.rightBoader]}>Frames</Text>
          <Text style={[styles.projectTitleinfoData, styles.rightBoader]}>{rowdata?.allocated_Frames}</Text>
          <Text style={[styles.projectInfoheadLine, styles.rightBoader]}>Cluster</Text>
          <Text style={[styles.projectInfoData, styles.rightBoader]}>{loadData?.cluster}</Text>
          <Text style={[styles.projectInfoTitleEnd, styles.rightBoader]}>Location Split up</Text>
          <Text style={[styles.projectInfoData]}>{loadData?.location_Split_up}</Text>
        </View>
        <View style={[styles.table,styles.removeTopBoader]}>
          <Text style={[styles.projectDetails]}>Project Checklist</Text>
        </View>
        <View style={[styles.row, styles.removeTopBoader]}>
          <Text style={[styles.ProjectChecklistHead, styles.rightBoader]}>Work Advice</Text>
          <Text style={[styles.ProjectChecklistData, styles.rightBoader]}>{loadData?.work_Advice}</Text>
          <Text style={[styles.ProjectChecklistHead, styles.rightBoader]}>Shot Estimate Report</Text>
          <Text style={[styles.ProjectChecklistData, styles.rightBoader]}>{loadData?.shot_Estimate_Report}</Text>
          <Text style={[styles.ProjectChecklistEndHead, styles.rightBoader]}>LTO Log</Text>
          <Text style={[styles.ProjectChecklistData]}>{loadData?.ltO_Log}</Text>
        </View>
        <View style={[styles.row, styles.removeTopBoader]}>
          <Text style={[styles.ProjectChecklistHead, styles.rightBoader]}>Contract Review</Text>
          <Text style={[styles.ProjectChecklistData, styles.rightBoader]}>{loadData?.contract_Review}</Text>
          <Text style={[styles.ProjectChecklistHead, styles.rightBoader]}>Project allocation Sheet</Text>
          <Text style={[styles.ProjectChecklistData, styles.rightBoader]}>{loadData?.project_allocation_Sheet}</Text>
          <Text style={[styles.ProjectChecklistEndHead, styles.rightBoader]}>Deletion Approval recd.</Text>
          <Text style={[styles.ProjectChecklistData]}>{loadData?.detection_Approval_reacd}</Text>
        </View>
        <View style={[styles.row, styles.removeTopBoader]}>
          <Text style={[styles.ProjectChecklistHead, styles.rightBoader]}>Analysis Report</Text>
          <Text style={[styles.ProjectChecklistData, styles.rightBoader]}>{loadData?.analysis_Report}</Text>
          <Text style={[styles.ProjectChecklistHead, styles.rightBoader]}>Daily Tracker</Text>
          <Text style={[styles.ProjectChecklistData, styles.rightBoader]}>{loadData?.daily_Tracker}</Text>
          <Text style={[styles.ProjectChecklistEndHead, styles.rightBoader]}>Project Brief</Text>
          <Text style={[styles.ProjectChecklistData]}>{loadData?.project_Brief}</Text>
        </View>
        <View style={[styles.row, styles.removeTopBoader]}>
          <Text style={[styles.ProjectChecklistHead, styles.rightBoader]}>QA Feedback Tracker</Text>
          <Text style={[styles.ProjectChecklistData, styles.rightBoader]}>{loadData?.qA_Feedback_Tracker}</Text>
          <Text style={[styles.ProjectChecklistHead, styles.rightBoader]}>Estimation Report</Text>
          <Text style={[styles.ProjectChecklistData, styles.rightBoader]}>{loadData?.estimation_Report}</Text>
          <Text style={[styles.ProjectChecklistEndHead, styles.rightBoader]}>QC Feedback Tracker</Text>
          <Text style={[styles.ProjectChecklistData]}>{loadData?.qC_Feedback_Tracker}</Text>
        </View>
        <View style={[styles.row, styles.removeTopBoader]}>
          <Text style={[styles.ProjectChecklistHead, styles.rightBoader]}>Estimation to Client</Text>
          <Text style={[styles.ProjectChecklistData, styles.rightBoader]}>{loadData?.estimation_to_Client}</Text>
          <Text style={[styles.ProjectChecklistHead, styles.rightBoader]}>Final Restoration Report</Text>
          <Text style={[styles.ProjectChecklistData, styles.rightBoader]}>{loadData?.final_Restoration_Report}</Text>
          <Text style={[styles.ProjectChecklistEndHead, styles.rightBoader]}>Project Plan and Tracker</Text>
          <Text style={[styles.ProjectChecklistData]}>{loadData?.project_Plan_and_Tracker}</Text>
        </View>
        <View style={[styles.row, styles.removeTopBoader]}>
          <Text style={[styles.ProjectChecklistHead, styles.rightBoader]}>Content Report</Text>
          <Text style={[styles.ProjectChecklistData]}>{loadData?.content_Report}</Text>
          <Text style={[styles.ProjectChecklistHead]}></Text>
          <Text style={[styles.ProjectChecklistData]}></Text>
          <Text style={[styles.ProjectChecklistEndHead]}></Text>
          <Text style={[styles.ProjectChecklistData]}></Text>
        </View>
        <View style={[styles.table,styles.removeTopBoader]}>
          <Text style={[styles.projectDetails]}>Project Metrics</Text>
        </View>
        <View style={[styles.row, styles.removeTopBoader]}>
          <Text style={[styles.ProjectChecklistHead, styles.rightBoader]}>Effort Variance</Text>
          <Text style={[styles.ProjectChecklistData, styles.rightBoader]}>{Math.round((parseInt(rowdata.total_Hours.toString())-parseInt(rowdata.estimate_Hour.toString()))/parseInt(rowdata.total_Hours.toString())*100)}</Text>
          <Text style={[styles.ProjectChecklistHead, styles.rightBoader]}>Schedule Variance</Text>
          <Text style={[styles.ProjectChecklistData]}>{loadData?.dayDifferent}</Text>
          <Text style={[styles.ProjectChecklistEndHead]}></Text>
          <Text style={[styles.ProjectChecklistData]}></Text>
        </View>
        <View style={[styles.row, styles.removeTopBoader]}>
          <Text style={[styles.ProjectChecklistHead, styles.rightBoader]}>Internal Frames Quality</Text>
          <Text style={[styles.ProjectChecklistData, styles.rightBoader]}></Text>
          <Text style={[styles.ProjectChecklistHead, styles.rightBoader,{textAlign:'center'}]}>{'QC'}</Text>
          <Text style={[styles.ProjectChecklistData]}></Text>
          <Text style={[styles.ProjectChecklistEndHead, {textAlign:'center'}]}>{'FQA'}</Text>
          <Text style={[styles.ProjectChecklistData]}></Text>
        </View>
        <View style={[styles.row, styles.removeTopBoader]}>
          <Text style={[styles.ProjectChecklistHead, styles.rightBoader]}>No. of Frames Rejected</Text>
          <Text style={[styles.ProjectChecklistData, styles.rightBoader]}></Text>
          <Text style={[styles.ProjectChecklistHead, styles.rightBoader,{textAlign:'center'}]}>{loadData?.qcFrame}</Text>
          <Text style={[styles.ProjectChecklistData]}></Text>
          <Text style={[styles.ProjectChecklistEndHead, {textAlign:'center'}]}>{loadData?.fqaFrame}</Text>
          <Text style={[styles.ProjectChecklistData]}></Text>
        </View>
        
        <View style={[styles.row, styles.removeTopBoader]}>
          <Text style={[styles.ProjectChecklistHead, styles.rightBoader]}>IMPROVEMENTS</Text>
          <Text style={[styles.ProjectChecklistData,{width: '74%',textAlign:'left',fontSize:8}]}>{loadData?.improvements}</Text>
          
        </View>
        <View style={[styles.row, styles.removeTopBoader]}>
          <Text style={[styles.ProjectChecklistHead, styles.rightBoader]}>Customer Complaints</Text>
          <Text style={[styles.ProjectChecklistData,{width: '74%',textAlign:'left',fontSize:8}]}>{loadData?.customer_Complaints}</Text>
        </View>
        <View style={[styles.row, styles.removeTopBoader]}>
          <Text style={[styles.ProjectChecklistHead, styles.rightBoader]}>DRE - QC</Text>
          <Text style={[styles.ProjectChecklistData,{width: '74%',textAlign:'left',fontSize:8}]}>{loadData?.drE_QC}</Text>
        </View>
        <View style={[styles.row, styles.removeTopBoader]}>
          <Text style={[styles.ProjectChecklistHead, styles.rightBoader]}>DRE - Client</Text>
          <Text style={[styles.ProjectChecklistData,{width: '74%',textAlign:'left',fontSize:8}]}>{loadData?.drE_Client}</Text>
        </View>
        <View style={[styles.table,styles.removeTopBoader]}>
          <Text style={[styles.projectDetails]}>Comments</Text>
        </View>
        <View style={[styles.row,styles.removeTopBoader]}>
          <Text style={[styles.tableHeader,styles.rightBoader,{width:'5%'}]}>Sl. No.</Text>
          <Text style={[styles.tableHeader,styles.rightBoader,{width:'10%'}]}>Int / Ext</Text>
          <Text style={[styles.tableHeader,styles.rightBoader,{width:'45%'}]}>Description</Text>
          <Text style={[styles.tableHeader,{width:'40%'}]}>Action taken</Text>
        </View>
        {pcrLoadComment!==null ? (pcrLoadComment.map((item, index) => (
        <View style={[styles.row, styles.removeTopBoader]} key={index}>
          <Text wrap={true} style={[styles.ChildTableData, styles.rightBoader, {width:'5%', textAlign: 'center', padding: 10}]}>{index+1}</Text>
          <Text style={[styles.ChildTableData, styles.rightBoader, {width: '10%', textAlign: 'center', padding: 10}]}>{item.int_Ext}</Text>
          <Text style={[styles.ChildTableData, styles.rightBoader, {width: '45%', textAlign: 'center', padding: 10}]}>{item.description}</Text>
          <Text style={[styles.ChildTableData,  {width: '40%', textAlign: 'center', padding: 10}]}>{item.action_Taken}</Text>
        </View>
      ))): 
      <View style={[styles.row, styles.removeTopBoader]}>
          <Text style={[styles.ChildTableData,{width: '100%',textAlign:'center'}]}>{'No Data Available'}</Text>
      </View>}
      <View style={[styles.row, styles.removeTopBoader]}>
      <Text style={[styles.ChildTableData,styles.rightBoader,{width:'10%'}]}>Note:</Text>
      <Text style={[styles.ChildTableData,{width: '90%',fontSize:8}]}>{loadData?.notes}</Text>
      </View>
        <View style={[styles.row,styles.removeTopBoader]}>
            <Text style={[styles.tableHeader,styles.rightBoader,{width:'10%'}]}></Text>
            <Text style={[styles.tableHeader,styles.rightBoader,{width:'25%'}]}>Delivery Manager</Text>
            <Text style={[styles.tableHeader,styles.rightBoader,{width:'20%'}]}>Quality Team</Text>
            <Text style={[styles.tableHeader,styles.rightBoader,{width:'20%'}]}>Technical  Team</Text>
            <Text style={[styles.tableHeader,{width:'25%'}]}>HOD</Text>
        </View>
        <View style={[styles.row,styles.removeTopBoader]}>
            <Text style={[styles.ChildTableData,styles.rightBoader,{width:'10%'}]}>Name</Text>
            <Text style={[styles.ChildTableData,styles.rightBoader,{width:'25%'}]}>{'S. Kamalakannan & J. Venkatesh'}</Text>
            <Text style={[styles.ChildTableData,styles.rightBoader,{width:'20%'}]}></Text>
            <Text style={[styles.ChildTableData,styles.rightBoader,{width:'20%'}]}></Text>
            <Text style={[styles.ChildTableData,{width:'25%'}]}>D. Jaikumar</Text>
        </View>
        <View style={[styles.row,styles.removeTopBoader]}>
            <Text style={[styles.ChildTableData,styles.rightBoader,{width:'10%',height:25}]}>Signing</Text>
            <Text style={[styles.ChildTableData,styles.rightBoader,{width:'25%',height:25}]}></Text>
            <Text style={[styles.ChildTableData,styles.rightBoader,{width:'20%',height:25}]}></Text>
            <Text style={[styles.ChildTableData,styles.rightBoader,{width:'20%',height:25}]}></Text>
            <Text style={[styles.ChildTableData,{width:'25%',height:25}]}></Text>
        </View>
        <View style={[styles.row,styles.removeTopBoader]}>
            <Text style={[styles.ChildTableData,styles.rightBoader,{width:'10%'}]}>Signing Date :</Text>
            <Text style={[styles.ChildTableData,styles.rightBoader,{width:'25%'}]}></Text>
            <Text style={[styles.ChildTableData,styles.rightBoader,{width:'20%'}]}></Text>
            <Text style={[styles.ChildTableData,styles.rightBoader,{width:'20%'}]}></Text>
            <Text style={[styles.ChildTableData,{width:'25%'}]}></Text>
        </View>
        <View style={[styles.row,styles.removeTopBoader]}>
            <Text style={[styles.ChildTableData,styles.rightBoader,{width:'10%'}]}>Signing Time :</Text>
            <Text style={[styles.ChildTableData,styles.rightBoader,{width:'25%'}]}></Text>
            <Text style={[styles.ChildTableData,styles.rightBoader,{width:'20%'}]}></Text>
            <Text style={[styles.ChildTableData,styles.rightBoader,{width:'20%'}]}></Text>
            <Text style={[styles.ChildTableData,{width:'25%'}]}></Text>
        </View>
      {/* } */}
    </Page>
  </Document>
);


  return (
    <>
     <div>
       <PDFViewer width="100%" height="1000">
      {PDFComponent}
    </PDFViewer>
    </div>
  </>
  )
}

export default PCRPdfDownload